// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-vergeten-tsx": () => import("./../../../src/pages/vergeten.tsx" /* webpackChunkName: "component---src-pages-vergeten-tsx" */),
  "component---src-templates-configurator-tsx": () => import("./../../../src/templates/configurator.tsx" /* webpackChunkName: "component---src-templates-configurator-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-product-tsx": () => import("./../../../src/templates/product.tsx" /* webpackChunkName: "component---src-templates-product-tsx" */)
}

